import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  bottomRow: {
    flexDirection: 'row',
  },
  centerContainer: {
    alignItems: 'center',
    height: Theme.px(280),
    justifyContent: 'center',
    width: Theme.px(802),
  },
  container: {
    flexDirection: 'column',
    height: Theme.px(120),
    width: Theme.px(800),
  },
  divider: {
    backgroundColor: Theme.whisperWhite,
    height: Theme.px(28),
    marginLeft: Theme.px(20),
    marginRight: Theme.px(20),
    marginTop: Theme.px(6),
    width: Theme.px(2),
  },
  topRow: {
    alignItems: 'center',
    flexDirection: 'row',
    height: Theme.px(77),
    justifyContent: 'flex-start',
    width: '100%',
  },
});
